import { request } from "/src/utils/index.js";

export function Search(params) {
  // console.log(parmas);
  return request.get("sdbs/vendor/list");
  // return request.get("sdbs/vendor/list", { params });
}